/* eslint-disable import/no-webpack-loader-syntax */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./translations/en.json";
import de from "./translations/de.json";
import fr from "./translations/fr.json";
import es from "./translations/es.json";
import ja from "./translations/ja.json";

const resources = {
  en: {translation: en},
  de: {translation: de},
  fr: {translation: fr},
  es: {translation: es},
  ja: {translation: ja}
};

/** Makes sure that unsupported languages are ignored */
const supportedLngs = Object.keys(resources);

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    detection: {
      cookieMinutes: 365*24*60 // one year
    },
    supportedLngs,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
export const t = i18n.t;